import React from 'react';

import { Header } from '@hz-design-system/web-ui';
import { hydrateRoot } from 'react-dom/client';

export const hydrateHeader = () => {
  const headerConfig = window.__HEADER_CONFIG__ || {};
  hydrateRoot(
    document.getElementById('header-root')!,
    <Header
      headerConfig={headerConfig as any}
      trackGAEvent={(e, l) => window.ecGa('trackEvent', { eventAction: e, eventLabel: l })}
    />,
  );
};
